import { jsx, jsxs } from 'react/jsx-runtime';
import paymentStatus from '../../../constants/paymentStatusConstants.js';
import { containerStyle, fieldsetStyle, radioLabel } from '../styles.js';
var StubbedStatusSelector = function StubbedStatusSelector(_ref) {
  var stubbedStatus = _ref.stubbedStatus,
    _onChange = _ref.onChange;
  return jsx("div", {
    style: containerStyle,
    children: jsxs("fieldset", {
      style: fieldsetStyle,
      children: [jsx("legend", {
        children: "Stubbed status options:"
      }), Object.values(paymentStatus).map(function (status) {
        return jsxs("label", {
          style: radioLabel,
          children: [jsx("input", {
            type: "radio",
            name: "stubbedStatus",
            value: status,
            checked: stubbedStatus === status,
            onChange: function onChange() {
              return _onChange(status);
            }
          }), status]
        }, status);
      })]
    })
  });
};
export { StubbedStatusSelector as default };